import { Component, ChangeDetectionStrategy, signal, inject, viewChild } from '@angular/core';
import { CustomerMasterData, Department } from '../customer.model';
import { CustomerService } from '../customer.service';
import { MainStore } from 'src/app/common/main.store';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { CustomerMasterdataComponent } from '../customer-masterdata/customer-masterdata.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-customer-create',
    templateUrl: './customer-create.component.html',
    styleUrl: './customer-create.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CustomerMasterdataComponent]
})
export class CustomerCreateComponent {
  private readonly customerService = inject(CustomerService);
  private readonly toastrService = inject(ToastrService);
  readonly activeModal = inject(NgbActiveModal);
  private readonly store = inject(MainStore);
  private readonly commonService = inject(CommonService);
  private readonly router = inject(Router);

  readonly customerMasterdataComponent = viewChild.required(CustomerMasterdataComponent);

  readonly canSaveCustomer = signal(true);
  readonly isCreatingCustomer = signal(false);
  readonly errorMessage = signal<{ message: string; location: 'storage' | 'personalStorage' | 'form' } | null>(null);
  readonly currentDepartment: Department = this.store.selectedDepartment.get()!;

  updateCanSave(isValid: boolean): void {
    this.canSaveCustomer.set(isValid);
  }

  async saveCustomer(customer: CustomerMasterData): Promise<void> {
    this.isCreatingCustomer.set(true);
    this.customerService.createCustomer(customer)
      .then(() => {
        // The customer exists, but its tenant DB is provisioning asynchronously. Leave the modal and
        // show progress on the customer list, where it can be finished once the DB is ready.
        this.toastrService.info('Kunden er oprettet. Tenant-databasen provisioneres nu.');
        this.commonService.CustomerListChanged.emit('nykunde');
        this.router.navigate(['/customers']);
        this.activeModal.close('Close');
      }).catch((e: HttpErrorResponse) => {
        const errorMsg: string = e.error?.message ?? '';
        const lower = errorMsg.toLowerCase();
        let location: 'storage' | 'personalStorage' | 'form' = 'form';
        if (lower.startsWith('storage')) location = 'storage';
        else if (lower.startsWith('personal storage')) location = 'personalStorage';
        this.errorMessage.set({ message: errorMsg, location });
      }).finally(() => {
        this.isCreatingCustomer.set(false);
      });
  }

  submitForm(): void {
    this.customerMasterdataComponent().submitForm();
  }
}
